export default __webpack_public_path__ + "static/media/icpc-logo-cmplay.ddb54466.png";